export default __webpack_public_path__ + "static/media/renagew-gray.f59ee58a.webp";